export default {
  title: 'Home',
  header: 'Home',
  topNotes: 'Top notes for the selected range',
  topArticles: 'Top articles for the selected range',
}
